import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    margin: '0 1rem',
    color: theme.palette.textLight,
    fontStyle: 'italic',
    fontSize: theme.size.sm
  }
}))

export default useStyles
